// extracted by mini-css-extract-plugin
export default {"tech":"technologyBeet_tech__0p6Sa"};